var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9532",
    "data-name": "Group 9532",
    transform: "translate(-201.159 -1522.467)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3325",
    "data-name": "Path 3325",
    d: "M208.662,1537.467a7.5,7.5,0,1,1,7.5-7.485A7.5,7.5,0,0,1,208.662,1537.467Zm6.418-7.456a6.421,6.421,0,1,0-6.408,6.377A6.432,6.432,0,0,0,215.08,1530.011Z",
    fill: "#fc6b76"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3326",
    "data-name": "Path 3326",
    d: "M232.287,1554.225c-.745-.707-1.45-1.317-2.074-2-.2-.219-.362-.767-.236-.932.337-.441.7-.109.994.194.643.666,1.285,1.333,2.046,2.123.736-.789,1.359-1.514,2.052-2.166a.965.965,0,0,1,.878-.187c.424.292.159.654-.134.936-.687.662-1.376,1.322-2.167,2.082.766.725,1.46,1.379,2.15,2.038.288.275.562.593.184.96s-.687.074-.961-.208c-.648-.668-1.292-1.339-2.027-2.1-.72.736-1.379,1.412-2.04,2.086-.271.276-.573.6-.956.231-.414-.4-.088-.721.21-1.014Z",
    transform: "translate(-24.308 -24.282)",
    fill: "#fc6b76"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.4b07597a368bfbae2846a221ad8b8fe4.svg";
export { ForwardRef as ReactComponent };